export const wardrobes = {
    metall_type: [
        {
            actual: true,
            name: "shkaf__shk__1850x820x450",
            pageName: "shk",
            tempName: "shk",
            glbPath: "wardrobes/",
            glbName: "shkafy_shk.glb",
            nextMenu: "shk",
            menuTitle: "Шкаф для комплектующих (ШК)",
            title: "Шкаф для комплектующих (ШК)",
            imgName: "wardrobe_shk.webp",
            allArrTable: "allWardrobes",
            defaultHeight: 1850,
            defaultWidth: 820,
            defaultDepth: 450,
        },
        {
            actual: true,
            name: "shkaf__sha__1950x1000x550",
            pageName: "sha",
            tempName: "sha",
            glbPath: "wardrobes/",
            glbName: "shkafy_sha.glb",
            nextMenu: "sha",
            menuTitle: "Шкаф архивный (ША)",
            title: "Шкаф архивный (ША)",
            imgName: "wardrobe_sha.webp",
            allArrTable: "allWardrobes",
            defaultHeight: 1950,
            defaultWidth: 1000,
            defaultDepth: 550,
        },
        {
            actual: true,
            name: "shkaf__shi__ship__2000x1020x620",
            pageName: "instrumentalniy",
            tempName: "instrumentalniy",
            glbPath: "wardrobes/",
            glbName: "shkafy_shi.glb",
            nextMenu: "instrumentalniy",
            menuTitle: "Шкаф инструментальный (ШИ)",
            title: "Шкаф инструментальный",
            imgName: "wardrobe_instrumentalniy.webp",
            allArrTable: "allWardrobes",
            defaultHeight: 2000,
            defaultWidth: 1020,
            defaultDepth: 620,
            wardrobeType: "shi",
        },
        {
            actual: false,
            name: "shkaf__shi__ship__2000x1020x620",
            pageName: "instrumentalniy",
            tempName: "instrumentalniy",
            glbPath: "wardrobes/",
            glbName: "shkafy_shi.glb",
            nextMenu: "instrumentalniy",
            menuTitle: "Шкаф инструментальный (ШИП)",
            title: "Шкаф инструментальный",
            imgName: "wardrobe_instrumentalniy.webp",
            allArrTable: "allWardrobes",
            defaultHeight: 2000,
            defaultWidth: 1020,
            defaultDepth: 620,
            folderName: "wardrobes",
            wardrobeType: "ship",
        },
        {
            actual: false,
            name: "shkaf__shir__shio__2000x1020x620",
            pageName: "instrumentalniy",
            tempName: "instrumentalniy",
            glbPath: "wardrobes/",
            glbName: "shkafy_shi.glb",
            nextMenu: "instrumentalniy",
            menuTitle: "Шкаф инструментальный (ШИР)",
            title: "Шкаф инструментальный",
            imgName: "wardrobe_instrumentalniy.webp",
            allArrTable: "allWardrobes",
            defaultHeight: 2000,
            defaultWidth: 1020,
            defaultDepth: 620,
            folderName: "wardrobes",
            wardrobeType: "shir",
        },
        {
            actual: false,
            name: "shkaf__shir__shio__2000x1020x620",
            pageName: "instrumentalniy",
            tempName: "instrumentalniy",
            glbPath: "wardrobes/",
            glbName: "shkafy_shi.glb",
            nextMenu: "instrumentalniy",
            menuTitle: "Шкаф инструментальный (ШИО)",
            title: "Шкаф инструментальный",
            imgName: "wardrobe_instrumentalniy.webp",
            allArrTable: "allWardrobes",
            defaultHeight: 2000,
            defaultWidth: 1020,
            defaultDepth: 620,
            folderName: "wardrobes",
            wardrobeType: "shio",
        },
    ],
    construct_type: [],
};
